import { createRouter, createWebHistory } from 'vue-router';
import EmailInput from '../components/EmailInput.vue';
import OtpInput from '../components/OtpInput.vue';
import RegistrationForm from '../components/RegistrationForm.vue';
import Welcome from '../components/WelcomeScreen.vue';
import WelcomeBack from '../components/WelcomeBack.vue'; // Importa el nuevo componente
import AgeTerms from '../components/AgeTerms.vue'; 
import WelcomeNewExperience from '../components/WelcomeNewExperience.vue'; 
import FacebookAuth from '../components/FacebookAuth.vue';
import AgeTermsFb from '../components/AgeTermsFb.vue';
import FacebookRegister from '../components/FacebookRegister.vue';
import GoogleAuth from '../components/GoogleAuth.vue';
import AgeTermsGoogle from '../components/AgeTermsGoogle.vue';
import GoogleRegister from '../components/GoogleRegister.vue';

const routes = [
  {  path: '/', component: EmailInput },
  { path: '/email', component: EmailInput },
  { path: '/otp', component: OtpInput },
  { path: '/register', component: RegistrationForm },
  { path: '/welcome', component: Welcome },
  { path: '/welcome-back', component: WelcomeBack },
  { path: '/age-terms', component: AgeTerms }, // Nueva ruta
  { path: '/welcome-new-experience', component: WelcomeNewExperience }, // Nueva ruta
  { path: '/facebook-auth', component: FacebookAuth },
  { path: '/age-terms-fb', component: AgeTermsFb },
  { path: '/facebook-register', component: FacebookRegister },
  { path: '/google-auth', component: GoogleAuth },
  { path: '/age-terms-google', component: AgeTermsGoogle },
  { path: '/google-register', component: GoogleRegister },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
